import React from 'react';
import { Link } from 'react-router-dom';


const TickerTape = ({items}) => {


    return (
        <div className="overflow-hidden whitespace-nowrap py-2">
            <div className="animate-marquee inline-block">
                {items.map((element, index) => (
                    <span key={index} className="mx-4  mr-4 text-4xl sm:text-2xl"><Link target='_blank' to={element.link}>{element.text}</Link><span className='ml-7 TickerTape'>{`.`}</span></span>
                ))}
                {items.map((element, index) => (
                    <span key={index + items.length} className="mx-4 mr-4 text-4xl sm:text-2xl"><Link target='_blank' to={element.link}>{element.text}</Link><span className='ml-7 TickerTape'>{`.`}</span></span>
                ))}
            </div>
        </div>
    );
};

export default TickerTape;
